import { environment } from 'environments/environment';
import { Injectable } from '@angular/core';
import * as _ from "lodash";
import { ActiveUserSession } from '../models/activeusersession';


@Injectable()

export class ActiveUserSessionService {

  activesession = new ActiveUserSession();

  localStorageSessionKey: string;
  localStorageSessionKey_isProductId: string;
  localStorageSessionKey_unintNo: string;
  localStorageSessionKey_unintName: string;
  localStorageSessionKey_isAllowFriendMenu: string;
  localStorageSessionKey_rolePage: string;
  localStorageSessionKey_resellerCustomer: string;


  constructor() {
    this.localStorageSessionKey = 'TNeGA-' + environment.apiBaseUrl + '-ActiveUser';
    this.localStorageSessionKey_isProductId = 'TNeGA-' + environment.apiBaseUrl + '-Product';
    this.localStorageSessionKey_unintNo = 'VumarReach-' + environment.apiBaseUrl + '-UnitNo';
    this.localStorageSessionKey_unintName = 'VumarReach-' + environment.apiBaseUrl + '-UnitName';
    this.localStorageSessionKey_isAllowFriendMenu = 'VumarReach-' + environment.apiBaseUrl + '-isAllowFriendMenu';
    this.localStorageSessionKey_rolePage = 'VumarReach-' + environment.apiBaseUrl + '-rolePage';
    this.localStorageSessionKey_resellerCustomer = 'VumarReach-' + environment.apiBaseUrl + '-ResellerCustomer';
  }

  create(activesession) {// jshint ignore:line
    this.setLocalStorageProperties(activesession);
  };
  createProductId(productId) {
    this.setLocalStoragePropertiesProductId(productId);
  }

  destroy() {// jshint ignore:line
    this.setLocalStorageProperties(new ActiveUserSession());
  };
  destroyProductId() {// jshint ignore:line
    this.setLocalStoragePropertiesProductId('');
  };
  load() { // jshint ignore:line
    const jsonData = localStorage.getItem(this.localStorageSessionKey);
    return jsonData;
  };
  setLocalStorageProperties(applicationInformation) {// jshint ignore:line
    localStorage.setItem(this.localStorageSessionKey, JSON.stringify(applicationInformation));
  };
  getUserDatas() {
    const jsonData = localStorage.getItem(this.localStorageSessionKey);
    return jsonData == null ? '' : JSON.parse(jsonData);
  }

  loadIsProductId() {
    const jsonData = localStorage.getItem(this.localStorageSessionKey_isProductId);
    return jsonData;
  };
  setLocalStoragePropertiesProductId(product) {
    localStorage.setItem(this.localStorageSessionKey_isProductId, JSON.stringify(product));
  };

  // getProductId() {
  //   const jsonData = localStorage.getItem(this.localStorageSessionKey_isProductId);
  //   return jsonData == null ? '' : JSON.parse(jsonData);
  // }


  getProductId() {
    const jsonData = localStorage.getItem(this.localStorageSessionKey_isProductId);

    if (jsonData === "undefined" || jsonData === null) {
      return ' ';
    }

    return JSON.parse(jsonData);
  }




  setLocalStoragePropertiesUnitNo(unitno) {
    localStorage.setItem(this.localStorageSessionKey_unintNo, JSON.stringify(unitno));
  };

  getUnitNo() {
    const jsonData = localStorage.getItem(this.localStorageSessionKey_unintNo);
    return jsonData == 'undefined' ? '' : JSON.parse(jsonData);
  }
  createUnitNo(unitno) {
    this.setLocalStoragePropertiesUnitNo(unitno);
  }
  destroyUnitNo() {// jshint ignore:line
    this.setLocalStoragePropertiesUnitNo('');
  };

  setLocalStoragePropertiesUnitName(unitno) {
    localStorage.setItem(this.localStorageSessionKey_unintName, JSON.stringify(unitno));
  };

  setLocalStoragePropertiesIsAllowFriendMenu(friendMenu) {
    localStorage.setItem(this.localStorageSessionKey_isAllowFriendMenu, JSON.stringify(friendMenu));
  };
  getUnitName() {
    const jsonData = localStorage.getItem(this.localStorageSessionKey_unintName);
    return jsonData == 'undefined' ? '' : JSON.parse(jsonData);
  }
  createUnitName(unitno) {
    this.setLocalStoragePropertiesUnitName(unitno);
  }
  destroyUnitName() {// jshint ignore:line
    this.setLocalStoragePropertiesUnitName('');
  };

  getIsAllowFriendMenu() {
    const jsonData = localStorage.getItem(this.localStorageSessionKey_isAllowFriendMenu);
    return jsonData == 'undefined' ? '' : JSON.parse(jsonData);
  }
  createIsAllowFriendMenu(friendMenu) {
    this.setLocalStoragePropertiesIsAllowFriendMenu(friendMenu);
  }
  destroyIsAllowFriendMenu() {// jshint ignore:line
    this.setLocalStoragePropertiesIsAllowFriendMenu('');
  };

  setLocalStoragePropertiesRolePage(page) {
    localStorage.setItem(this.localStorageSessionKey_rolePage, JSON.stringify(page));
  };

  createRolePage(page) {
    this.setLocalStoragePropertiesRolePage(page);
  }
  getRolePage() {
    const jsonData = localStorage.getItem(this.localStorageSessionKey_rolePage);
    return jsonData == 'undefined' ? '' : JSON.parse(jsonData);
  }
  destroyRolePage() {// jshint ignore:line
    this.setLocalStoragePropertiesRolePage('');
  };

  setLocalStoragePropertiesResellerCustomer(customer) {
    localStorage.setItem(this.localStorageSessionKey_resellerCustomer, JSON.stringify(customer));
  };

  createResellerCustomer(customer) {
    this.setLocalStoragePropertiesResellerCustomer(customer);
  }

  getResellerCustomer() {
    const jsonData = localStorage.getItem(this.localStorageSessionKey_resellerCustomer);

    if (jsonData === "undefined" || jsonData === null) {
      return null;
    }

    return JSON.parse(jsonData);
  }

  destroyResellerCustomer() {// jshint ignore:line
    this.setLocalStoragePropertiesResellerCustomer('');
  };
}

